import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import "./Reach.css";

const Reach = () => {
  const stats = [
    {
      num: "1.5B+",
      label: "Streams",
      icon: "Images/pricing-icon/icon-music.svg",
    },
    {
      num: "150+",
      label: "Platforms",
      icon: "Images/pricing-icon/icon-unlimited.svg",
    },
    {
      num: "Upto 90%",
      label: "Royalty to You",
      icon: "Images/pricing-icon/i-coin.svg",
    },
  ];

  return (
    <section className="reach-section-premium">
      <Container>
        <Row className="align-items-center gy-5">
          {/* Stats Column */}
          <Col lg={6}>
            <div className="reach-stats-grid-premium">
              {stats.map((stat, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1 }}
                  className="reach-stat-card"
                >
                  <div className="stat-icon-premium">
                    <Image src={stat.icon} alt={stat.label} />
                  </div>
                  <div className="stat-info-premium">
                    <h3 className="stat-number-premium">{stat.num}</h3>
                    <p className="stat-label-premium">{stat.label}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </Col>

          {/* CTA Card Column */}
          <Col lg={6}>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              className="growth-card-premium"
            >
              <div className="growth-content-premium">
                <h3 className="growth-heading-premium">
                  Want to{" "}
                  <span className="text-purple-gradient">Reach More Fans</span>{" "}
                  and Increase Your Streams?
                </h3>
                <p className="growth-desc-premium">
                  FT Tunes Accelerator helps self-releasing artists do both.
                </p>
                <p>FT Tunes Accelerator empowers self-releasing artists to boost their discoverability and expand their global audience.

Discover how FT Tunes Accelerator can elevate your music career and experience the difference for yourself.</p>
                <motion.a
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  href="https://dashboard.fttunes.com/register.php"
                  className="btn-growth-premium button_button__MFmXH button_color__bLscP"
                >
                  Sign Up <span className="ms-2">→</span>
                </motion.a>
              </div>
              <div className="growth-visual-premium">
                <div className="chart-bars-premium">
                  {[...Array(5)].map((_, i) => (
                    <motion.div
                      key={i}
                      initial={{ height: 0 }}
                      whileInView={{ height: `${20 + i * 20}%` }}
                      transition={{ duration: 1, delay: i * 0.1 }}
                      className="chart-bar-item"
                    ></motion.div>
                  ))}
                </div>
                <Image
                  src="Images/pricing-icon/icon-waveform.svg"
                  className="growth-bg-icon"
                />
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Reach;
